
import { LoaderFunction, type MetaFunction } from "@remix-run/node";
import { json, useLoaderData } from "@remix-run/react";
import { getDeviceInfo } from "~/lib/hooks/useViewportListener";
import { DEFAULT_REGION } from "~/lib/constants/generalConstants";
import CoStats from "~/components/blocks/Co-StatsPage";
import { getCountryName } from "~/lib/helpers/constants";
import { CostatsMeta } from "~/utils/Meta/co-statsMeta";


export const meta: MetaFunction = ({ data, location }) => {
    if (!data || !location) return [];
    return CostatsMeta({ data, path: location.pathname || '/' });
};

export const loader: LoaderFunction = async ({ params, request }) => {
    const countryCode = params.country || DEFAULT_REGION;
    const country = getCountryName(countryCode);

    const { isMobile } = getDeviceInfo(request, 1024);

    return json({ isMobile, country, countryCode });
};

export default function CoStatsPage() {
    const { isMobile, country, countryCode } = useLoaderData<typeof loader>();

    return (
        <div className="min-h-screen">
            <CoStats isMobile={isMobile} country={country} region={countryCode} />
        </div>
    );
}
